import { HIDE_REMOVE_ICON, HIDE_SAVE_BUTTON } from 'constants/manageResumeFields';
import { ARRAY_FIELDS, SAVING_FIELDS } from 'constants/resumeForm';
import useTranslate from 'hooks/useTranslate';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useSaveResumeMutation } from 'services';
import useResumeStore from 'store/resume';
import { checkObjHasValues } from 'utils';

const ActionMenu = ({
	handleRemoveClick,
	slug,
	contentSlug,
	handleModalVisibility,
	formikObj,
	handleTitleChange,
}: any) => {
	const { translate } = useTranslate();
	const [editing, setEditing] = useState(false);
	const { resumeData }: any = useResumeStore((state) => state || {});
	const defaultTitle = resumeData?.[slug];
	const fieldVisibility = resumeData?.manageTemplateFields?.[contentSlug];
	const [saveText, setSaveText] = useState<string>(translate('Resume.save'));

	// mutation
	const { mutateAsync: saveResumeMutation, isPending } = useSaveResumeMutation();

	const { slug: templateId } = useParams();

	const handleEdit = () => setEditing(true);

	const handleSave = () => {
		if (defaultTitle) {
			setEditing(false);
		}
	};

	const handleKeyDown = (e: any) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleSave();
		}
	};

	const saveResume = async (finalData: any) => {
		try {
			const response = await saveResumeMutation({
				...finalData,
				templateId: Number(templateId),
			});
			if (response?.success) {
				setTimeout(() => {
					setSaveText(translate('Resume.saved'));
				}, 500);
			}
		} finally {
			setTimeout(() => {
				setSaveText('Save');
			}, 1000);
		}
	};

	const handleSaveButtonClick = (event: any) => {
		if (!formikObj || (formikObj?.errors && !Object.keys(formikObj?.errors)?.length)) {
			event.preventDefault();
			setSaveText(translate('Resume.saving'));

			const fieldsData: any = { ...resumeData };
			const savingFields: any = SAVING_FIELDS[slug];
			const finalData: any = {};
			savingFields?.length > 0 &&
				savingFields?.map((field: string, key: number) => {
					if (
						ARRAY_FIELDS?.includes(field) &&
						fieldsData[field] &&
						fieldsData[field]?.length > 0 &&
						!checkObjHasValues(fieldsData[field][fieldsData[field]?.length - 1])
					) {
						finalData[field] = fieldsData[field].slice(0, -1);
					} else {
						finalData[field] = fieldsData[field];
					}
				});

			// required fields:
			finalData['detailTitle'] = fieldsData['detailTitle'];
			finalData['details'] = fieldsData['details'];
			finalData['manageTemplateFields'] = fieldsData['manageTemplateFields'];
			saveResume(finalData);
		}
	};

	return (
		<div className="d-flex align-items-center justify-content-between gap-3">
			<div className="left-content d-flex align-items-center gap-2">
				{editing ? (
					<Form.Control
						placeholder={translate('PlaceHolder.title')}
						defaultValue={defaultTitle}
						className={`fw-bold p-0 border-0 w-100 ${defaultTitle ? '' : 'not-valid-input'}`}
						onChange={(e) => handleTitleChange(slug, e.target.value)}
						onKeyDown={handleKeyDown}
						name={slug}
						autoFocus
					/>
				) : (
					<h5 className="mb-0 fw-bold">{defaultTitle}</h5>
				)}

				<Button
					variant="link"
					onClick={() => (editing ? handleSave() : handleEdit())}
					className="text-decoration-none mb-0 p-0 border-0"
				>
					<i className={editing ? 'ri-check-line' : 'ri-pencil-line'}></i>
				</Button>
			</div>
			<div>
				{!HIDE_REMOVE_ICON.includes(contentSlug) && (
					<Button
						variant="link"
						className={`delete-info text-decoration-none border-0 p-0 ${fieldVisibility ? '' : 'filled-btn add-info rounded-circle text-white'}`}
						onClick={() =>
							fieldVisibility
								? handleModalVisibility(contentSlug, undefined, formikObj)
								: handleRemoveClick(contentSlug)
						}
					>
						<i className={fieldVisibility ? 'ri-delete-bin-line' : 'ri-add-line'}></i>
					</Button>
				)}
				{!HIDE_SAVE_BUTTON.includes(contentSlug) && fieldVisibility && (
					<Button
						type="submit"
						variant="link"
						className="filled-btn text-decoration-none rounded-pill save-btn text-white ms-2 ms-md-3"
						onClick={(event) => handleSaveButtonClick(event)}
						disabled={saveText !== translate('Resume.save')}
					>
						{saveText}
					</Button>
				)}
			</div>
		</div>
	);
};

export default React.memo(ActionMenu);
